import React from 'react';
import moment from 'moment';
import 'moment-duration-format';
import { strings } from 'APP_ROOT/localization';
import RavenUtil from 'APP_ROOT/components/common/ravenUtil';

const titleFor = (card) => {
    if (!card) return '';
    const vehicleName = card.vehicle && card.vehicle.name;
    if(vehicleName) {
        return strings.formatString(card.type === 'PARKED'
            ? strings.card_title_parked_with_car_persona_fmt
            : strings.card_title_trip_with_car_persona_fmt,
            vehicleName);
    } else {
        return card.type === 'PARKED'
            ? strings.card_title_parked_no_car_persona
            : strings.card_title_trip_no_car_persona;
    }
};

const subtitleFor = (card) => {
    const { start } = card;
    // on Mar 3 at 2:45 PM
    return strings.formatString(strings.card_subtitle_fmt,
        moment(start.ts).format("MMM DD"),
        moment(start.ts).format("LT")
    );
};

const CardHeader = ({card}) => (
    <div className="card-header">
        {card ? (
            <h3>
                {titleFor(card)}
                <small>
                    {subtitleFor(card)}
                </small>
            </h3>
        ) : (
            <h3>{strings.card_title_no_trip}</h3>
        )}
    </div>
);

export default CardHeader;
